/**
 * Class description
 *
 * Created: 2018-01-29
 * @author jonas
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Linear, Power2, TimelineLite, TweenLite} from "gsap"
import {DungeonQuestHelper} from "../../bigSymbols/DungeonQuestHelper";
import {ShakeConfig, ShakeEffect} from "../../display/effects/ShakeEffect";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";
import {DungeonQuestSymbols} from "../../DungeonQuestGameConfig";
import {DungeonQuestBaseStateSprite} from "./DungeonQuestBaseStateSprite";


export class DungeonQuestWinStateTimelineSprite extends DungeonQuestBaseStateSprite {
    private _winSprite:PIXI.Sprite;
    private _symName:string;
    private _normalSprite:PIXI.Sprite;

    private _winType:number;
    private _scaleContainer:PIXI.Container;
    private _winParticles:TimelineSprite;
    private _winParticlesGlow:TimelineSprite;

    constructor(winType:number, symName:string, textures:PIXI.Texture[], sourceFPS?:number) {
        super(textures, sourceFPS);
        this._symName = symName;
        this._winType = winType;
        this.initLocal();
    }


    protected initLocal() {
        this._scaleContainer = new PIXI.Container();

        this._normalSprite = new PIXI.Sprite(this._textures[0]);
        this._normalSprite.anchor.set(0.5, 0.5);

        this._winSprite = new PIXI.Sprite(DungeonQuestGameAssets.getSymbolStateTextures(this._symName, "win")[0]);
        this._winSprite.anchor.set(0.5, 0.5);

        if(this._symName == DungeonQuestSymbols.S) {
            this._normalSprite = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.SCATTER_TWO_ATTENTION_FRAME)[0]);
            this._normalSprite.position.set(-1, -3);
            this._normalSprite.anchor.set(0.5, 0.5);

            this._winSprite.position.set(3, 2);
            this._winSprite.anchor.set(0.5, 0.5);
            this._winSprite.alpha = 0;
        }

        this._scaleContainer.addChild(this._normalSprite);
        this._scaleContainer.addChild(this._winSprite);


        this._winParticlesGlow = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.SYMBOL_WIN_PARTICLES_GLOW));
        this._winParticlesGlow.anchor.set(0.5, 0.5);
        this._winParticlesGlow.tint = DungeonQuestHelper.getSymbolColor(this._symName);
        this._winParticlesGlow.blendMode = PIXI.BLEND_MODES.ADD;

        this._winParticles = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.SYMBOL_WIN_PARTICLES));
        this._winParticles.anchor.set(0.5, 0.5);
        this._winParticles.blendMode = PIXI.BLEND_MODES.ADD;


        this.setUp();
        this.addChild(this._scaleContainer);
        this.addChild(this._winParticlesGlow);
        this.addChild(this._winParticles);


        this._textures[0] = PIXI.Texture.EMPTY;
        this.texture = PIXI.Texture.EMPTY;

    }

    private setUp() {
        this._winSprite.alpha = 0;
        this._winParticles.hide();
        this._winParticlesGlow.hide();
    }

    public getAnimation(frames?:number[], onUpdateCallback?:() => void, onCompleteCallback?:() => void):TimelineLite {
        const tl:TimelineLite = <TimelineLite>super.getAnimation(frames, onUpdateCallback, onCompleteCallback);
        tl.add(() => this.moveSymbolToTop());

        //0 = toggling
        if(this._winType == 0) {
            tl.add([
                new TweenLite(this._scaleContainer.scale, 0.2, {x : 1.15, y : 1.15, ease : Power2.easeIn}),
                //    new TweenLite(this._winSprite, 0.2, {alpha:0.2}),
            ]);
            tl.add([
                new TweenLite(this._scaleContainer.scale, 0.2, {x : 1.0, y : 1.0, ease : Power2.easeOut}),
                // new TweenLite(this._winSprite, 0.2, {alpha:0}),
            ], "+=0.5");
            tl.add(() => this.setUp());
            return tl;
        }


        let windUpScale:number = 0.70;
        const windUpDur:number = DungeonQuestHelper.getSymbolWindUpDuration(this._winType);
        let targetAlpha:number = 0.2;
        let showBurst:boolean = false;
        let shake:ShakeEffect | null = null;
        let burstScale:number = 0.75;

        if(this._winType == 1) {
            targetAlpha = 1;
            showBurst = false;

        } else if(this._winType == 2) {
            targetAlpha = 1;
            showBurst = !DungeonQuestHelper.isLowWin(this._symName);

        } else if(this._winType == 3) {
            targetAlpha = 1;
            showBurst = !DungeonQuestHelper.isLowWin(this._symName);
            shake = new ShakeEffect([this], new ShakeConfig(2));
            burstScale = 1;
        }


        //Wind up
        tl.add([
            new TweenLite(this._scaleContainer.scale, windUpDur, {
                x : windUpScale,
                y : windUpScale,
                ease : Linear.easeIn
            }),
            new TweenLite(this._winSprite, windUpDur * 0.7, {
                alpha : targetAlpha,
                ease : Linear.easeIn,
                delay : windUpDur * 0.3
            })
            //insert shake
        ]);

        if(shake) {
            tl.add(shake.getOneShotShake(windUpDur * 0.7), windUpDur * 0.3);
        }

        //release
        tl.add(new TweenLite(this._scaleContainer.scale, 0.1, {x : 1.27, y : 1.27, ease : Power2.easeIn}));
        const burstStartTime = tl.totalDuration();
        tl.add([
            new TweenLite(this._scaleContainer.scale, 0.3, {x : 1.0, y : 1.0, ease : Power2.easeOut}),
            new TweenLite(this._winSprite, 0.2, {alpha : 0}),

        ]);

        if(showBurst) {
            tl.add([
                () => this._winParticlesGlow.scale.set(burstScale),
                () => this._winParticles.scale.set(burstScale)
            ], burstStartTime);
            tl.add([
                () => this._winParticlesGlow.getAnimationAutoShowHide(true, true),
                () => this._winParticles.getAnimationAutoShowHide(true, true)
            ], burstStartTime);
        }

        tl.add(() => this.setUp());

        return tl;
    }

}